import { FunctionComponent } from "react";
import { BetsSummaryProps } from "./BetsSummary.types";
import { BetSegmentsSize } from "../BetSegments/BetSegments.types";
import { BetSegments } from "../BetSegments/BetSegments.web";
import styles from "./BetsSummary.web.css";

export const BetsSummary: FunctionComponent<BetsSummaryProps> = ({
  disabled = false,
  totalStake,
  totalStakeLabel,
  totalReturns,
  totalReturnsLabel,
  totalOriginalReturns,
  isOddsBoosted = false,
}) => (
  <div className={styles.betsSummary} aria-disabled={disabled}>
    <BetSegments
      leftLabel={totalStakeLabel}
      leftValue={totalStake}
      rightLabel={totalReturnsLabel}
      rightValue={totalReturns}
      rightPreviousValue={totalOriginalReturns}
      size={BetSegmentsSize.LARGE}
      isOddsBoosted={isOddsBoosted}
      isLeftSegmentOdds={false}
    />
  </div>
);
